<template>
  <div class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" id="stageModal">
    <div class="modal-dialog  modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header header-dark">
          <h5 class="modal-title">Pick Complete / Stage {{ order.number }}</h5>
          <button class="btn btn-secondary btn-sm" @click="allGood">
            <i class="far fa-check-square"></i> All Good</button>
        </div>
        <div class="modal-body p-0" id="stage">
          <table class="table table-sm table-striped border-bottom mb-0">
            <thead class="thead-light">
              <th>Name</th>
              <th>SKU</th>
              <th>UPC</th>
              <th>Location</th>
              <th>Qty</th>
              <th>Picked</th>
            </thead>
            <tbody>
              <tr v-for="inv in inventory" :key="inv.id">
                <td>{{ inv.name }}</td>
                <td>{{ inv.sku }}</td>
                <td>{{ inv.upc }}</td>
                <td>
                  <span v-if="inv.parent_bin">{{ inv.parent_bin_name }} / </span>
                  {{ inv.bin_name }}
                </td>
                <td><a href="#" @click="inv.qty_picked = inv.qty">{{ inv.qty }}</a></td>
                <td style="width: 100px;">
                  <input
                    class="form-control form-control-sm"
                    v-model="inv.qty_picked"
                    type="number"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-right p-2">
            <vue-select
              model="order.staged_by"
              placeholder="Who staged this ?"
              :options="users"
              label="name"
            />
          </div>                  
        </div>
        <div class="modal-footer">      
          <div class="alert alert-danger" v-if="!valid">
            All fields are required!
          </div>            
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button :disabled="!valid || updating" type="button" class="btn btn-primary" @click="submit">
            <i class="fa fa-spinner fa-spin" v-if="updating"></i>
            <i class="far fa-check-circle"></i> Stage
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSelect from 'vue-select'
import userStore from '@/stores/users'

import user from '@/libs/user'

export default {
  updating: false,
  name: 'stage-modal',
  components: { VueSelect },
  props: { order: Object },

  data() {
    return {

    }
  },

  created() {
    this.fetchData()
  },

  computed: {
    users() {
      return userStore.state.users
    },

    inventory() {
      return this.order.allocated_inventory.filter(inv => !inv.kit)
    },

    valid() {
      let valid = true
      this.inventory.forEach(inv => {
        if (inv.qty_picked == null || inv.qty_picked == '') {
          valid = false
        }
      })

      return valid
    }
  },

  methods: {
    allGood() {
      this.inventory.forEach(inv => {
        inv.qty_picked = inv.qty
      })
    },

    submit() {
      this.updating = true
      if (this.valid) {
        this.$emit('stage-order', this.inventory)
        this.updating = false
      }
    },

    fetchData() {
      user.all().then(res => {
        userStore.setUsers(res.data.users)
      })
    }
  }
}
</script>